import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { catalogBibShape, ugcCommentShape, libraryShape } from '@bibliocommons/bc-prop-types';
import Divider from 'app/components/bibs/shared/Divider';
import CommentDisplayContainer from 'app/components/bibs/shared/ugc/CommentDisplay';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';

import './CommentPage.scss';

export class CommentPage extends React.PureComponent {
  componentDidMount() {
    this.fetchRelationships();
  }

  fetchRelationships() {
    const { comment, currentUserId, relationshipsActions } = this.props;
    const authorUserId = comment.get('userId', null);

    if (currentUserId && authorUserId) {
      relationshipsActions.getRelationships({ userId: currentUserId, userIds: Immutable.List([authorUserId]) });
    }
  }

  renderUgcDisclaimer() {
    const { currentLibrary } = this.props;
    return (
      currentLibrary?.get('ugcDisclaimerMessageEnabled') && (
        <CommunityDisclaimer type="comment" currentLibrary={currentLibrary} />
      )
    );
  }

  render() {
    const { comment, catalogBib } = this.props;

    return (
      <div className="cp-comment-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="comment">
          <Divider />
          {this.renderUgcDisclaimer()}
          <CommentDisplayContainer
            comment={comment}
            key={comment.get('id')}
            displayStaffBadge={false}
            catalogBib={catalogBib}
          >
            {comment.get('comment')}
          </CommentDisplayContainer>
        </BibSubPage>
      </div>
    );
  }
}

CommentPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  comment: ugcCommentShape.isRequired,
  currentUserId: PropTypes.number,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentLibrary: libraryShape.isRequired
};

export default CommentPage;
